<template>
  <div
    v-if="store.loading"
    class="progress-bar">
    <div class="progress-bar-moving-part" />
  </div>
</template>

<script>
import ProgressBarStore from '../../../shared/ProgressBarStore';

export default {
  name: 'ProgressBar',

  data () {
    return {
      store: ProgressBarStore.data
    };
  }
};
</script>
